import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { StackDirectives } from 'src/app/shared/directives/stack-directives';
import { environment } from 'src/environments/environment.prod';
import { TabsModule } from 'primeng/tabs';

@Component({
  selector: 'app-login-page',
  imports: [StackDirectives, RouterOutlet, TabsModule],
  templateUrl: './login-page.component.html',
  styleUrls: ['./login-page.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoginPageComponent {
  constructor() {
    // console.log('🔥Versión: ', environment.version);
  }
}
